module.exports = __webpack_public_path__ + "images/bg-voucher-n.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-voucher-n.png
// module id = 831
// module chunks = 130